import { Component, Output, EventEmitter } from '@angular/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'rx-intuitive-summary-footer',
	templateUrl: './rx-intuitive-summary-footer.component.html',
	styleUrls: ['./rx-intuitive-summary-footer.component.scss'],
	standalone: true,
	imports: [TlkButtonComponent, TranslateModule]
})
export class RxIntuitiveSummaryFooterComponent {
	@Output() sendClicked = new EventEmitter<void>();
}
